module.exports = __webpack_public_path__ + "7ae918a48a038316eeecd597d2db1064.png";